import ProgressBar from 'react-bootstrap/ProgressBar';
import './ProgressBarIcon.scss';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
type Props = {
    value: number;
    count: number;
    maxvalue: number;
     label: string;
     icon: string;

};



export const ProgressBarIcon: React.FC<Props> = (props: Props) => {
    const navigate = useNavigate();


    return (
        <div className="bar">
            <div className="flex justify-content-between align-items-end gap-3">
<div className="d-flex gap-2">
                <img width={20} src={props.icon}></img>
<label className='labelProgressBarIcon' htmlFor="">{props.label}</label>
</div>
                <label  className='labelProgressBarIcon' htmlFor="">{props.count}</label>
            </div>
            <ProgressBar min={0} max={props.maxvalue}  now={props.value} />

        </div>
    );
};